import React from 'react';
import PropTypes from 'prop-types';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import PeriodRadioGroup, { defaultPeriods } from '@ecp/common/src/components/periodSearch/bo/PeriodRadioGroup';
import { CalendarRange } from '@ecp/common/src/components/calendar/bo/Calendar';
import usePeriodSearch from '@ecp/common/src/components/periodSearch/usePeriodSearch';

const PeriodSearch = ({ minDate, selectOnly, readOnly, ...props }) => {
  const { periodDates, periods, handlePeriodClick, handleFromDateChange, handleToDateChange, handleAllDateChange } =
    usePeriodSearch(props);

  return (
    <FlexBox gap={'6px'}>
      <CalendarRange
        startMinDate={minDate}
        startDate={periodDates?.from}
        endDate={periodDates?.to}
        onStartChange={handleFromDateChange}
        onEndChange={handleToDateChange}
        onAllDateChange={handleAllDateChange}
        selectOnly={selectOnly}
        readOnly={readOnly}
      />
      <PeriodRadioGroup periods={periods} value={periodDates?.period?.value} onClick={handlePeriodClick} />
    </FlexBox>
  );
};

export default PeriodSearch;

PeriodSearch.propTypes = {
  onChange: PropTypes.func,
  periods: PropTypes.array,
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  fromDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  toDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  period: PropTypes.object,
  defaultFromDate: PropTypes.instanceOf(Date),
  defaultToDate: PropTypes.instanceOf(Date),
  defaultPeriod: PropTypes.object,
  enableRadioSearch: PropTypes.bool,
  unControlled: PropTypes.bool,
  selectOnly: PropTypes.bool,
  readOnly: PropTypes.bool,
  format: PropTypes.string,
};

PeriodSearch.defaultProps = {
  direction: 'row',
  period: {},
  periods: defaultPeriods,
  unControlled: true,
  format: 'yyyyMMddHHmmss',
};
